<template>
  <div class="booksTable-container" ref="booksTableItem">
    <el-table
      ref="multipleTable"
      class="booksTable-content"
      :data="tableData"
      width="100%"
      :height="resetHeight"
      :header-cell-style="tableHeaderColor"
      @filter-change="filtersHandle"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        fixed="left"
        v-if="selectCtrl"
        width="50"
      >
      </el-table-column>
      <el-table-column
        v-for="{ prop, label, width, btn } in tableProps"
        :prop="prop"
        :key="prop"
        :label="label"
        align="center"
        :columnKey="prop"
        :fixed="prop === 'handle' ? 'right' : false"
        :filters="isFilters(prop)"
        :width="width"
        show-overflow-tooltip
        v-if="prop != isHandle"
      >
        <template slot-scope="scope" ref="test">
          <div v-if="prop === 'cover'">
            <img class="booksTable-cover" :src="scope.row.cover" alt="" />
          </div>
          <div
            class="omitText"
            v-else-if="
              prop === 'updated_at' ||
              prop === 'created_at' ||
              prop === 'updatedAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>
          <div v-else-if="prop === 'move'">
            <el-button
              size="mini"
              :disabled="scope.$index === 0"
              @click="moveUp(scope.$index, scope.row)"
              ><i class="el-icon-arrow-up"></i
            ></el-button>

            <el-button
              size="mini"
              :disabled="scope.$index === tableData.length - 1"
              @click="moveDown(scope.$index, scope.row)"
              ><i class="el-icon-arrow-down"></i
            ></el-button>
          </div>

          <div v-else-if="prop === 'status'">
            <span v-if="scope.row[prop] === 1">{{
              $t("content.books.soldOn")
            }}</span>
            <span v-else>{{ $t("content.books.soldOut") }}</span>
          </div>
          <div v-else-if="prop === 'handle'">
            <span
              :class="btnStyle(item)"
              v-for="item in btn"
              :key="item"
              plain
              @click="tableHandle(item, scope)"
              >{{ item }}</span
            >
          </div>

          <span v-else class="omitText">{{
            scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableProps: {
      type: Array,
    },
    selectCtrl: {
      type: Boolean,
      default: false,
    },
    isHandle: {
      type: String,
    },
  },
  data() {
    return {
      resetHeight: null,
      selectDataIds: [],
    };
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },
    resetSize() {
      this.$nextTick(() => {
        this.resetHeight = this.$refs.booksTableItem.offsetHeight - 6;
      });
    },
    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.check"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
          className = "delBtn";
          break;

        default:
          break;
      }
      return className;
    },
    isFilters(prop) {
      switch (prop) {
        case "rate":
          return [
            { text: this.$t("content.books.one"), value: 1 },
            { text: this.$t("content.books.two"), value: 2 },
            { text: this.$t("content.books.three"), value: 3 },
            { text: this.$t("content.books.four"), value: 4 },
            { text: this.$t("content.books.five"), value: 5 },
          ];
        case "status":
          return [
            { text: this.$t("content.books.soldOn"), value: 1 },
            { text: this.$t("content.books.soldOut"), value: 0 },
          ];
        default:
          return null;
      }
    },

    filtersHandle(obj) {
      let key = Object.keys(obj);
      this.$emit("filterEvn", { obj, key: key[0] });
    },
    handleSelectionChange(val) {
      this.selectDataIds = val.map((item) => item.id);
      this.$emit("selectEvnTable", this.selectDataIds);
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type,
        data: scope,
      };
      this.$emit(evn, obj);
    },
    tableHandle(type, scope) {
      if (type === this.$t("commonMsg.check")) {
        this.emitEvn(type, scope, "tableHandle");
      }
    },
    //        排序
    moveUp(index, row) {
      var that = this;
      if (index > 0) {
        let upDate = that.tableData[index - 1];
        that.tableData.splice(index - 1, 1);
        that.tableData.splice(index, 0, upDate);
        //                排序接口
        const ids = {
          b1: that.tableData[index].id,
          b2: that.tableData[index - 1].id,
          libraryId: this.$route.query.id,
        };
        this.$http
          .bookOrder(ids)
          .then((res) => {})
          .catch((err) => {});
      } else {
        //                alert('已经是第一条，不可上移');
      }
    },
    moveDown(index, row) {
      var that = this;
      if (index + 1 === that.tableData.length) {
        //                alert('已经是最后一条，不可下移');
      } else {
        let downDate = that.tableData[index + 1];
        that.tableData.splice(index + 1, 1);
        that.tableData.splice(index, 0, downDate);
        const ids = {
          b1: that.tableData[index].id,
          b2: that.tableData[index + 1].id,
          libraryId: this.$route.query.id,
        };
        this.$http
          .bookOrder(ids)
          .then((res) => {})
          .catch((err) => {});
      }
    },
  },
  watch: {
    tableData(arr) {
      if (arr.length) {
        this.resetSize();
      }
    },
  },
  mounted() {
    this.resetHeight = this.$refs.booksTableItem.offsetHeight - 6;
    window.addEventListener("resize", this.resetSize);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("resize", this.resetSize);
    });
  },
};
</script>

<style lang="scss">
.booksTable-container {
  height: 100%;
  overflow: hidden;
  .booksTable-cover {
    width: 40px;
    height: auto;
  }
}
</style>
